import { inject, Injectable } from '@angular/core';
import { CompoApiService } from 'compob2b-libs';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import type { SeoConfig } from '../../../server/seo-config.contract';

/**
 * Тонкий клиент `GET /seo/config`. На SSR anon-Bearer навешивает существующий
 * `anonAuthInterceptor` (как для `/catalog/tree`, `/product`). Возвращает `data` из
 * конверта `ApiResponse`.
 */
@Injectable({ providedIn: 'root' })
export class SeoConfigClient {
  private readonly api = inject(CompoApiService);

  fetch(): Observable<SeoConfig> {
    return this.api.get<SeoConfig>('/seo/config').pipe(map((r) => r.data));
  }
}
